(() => {
  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function restartKenBurns(slide) {
    const img = slide.querySelector('.hero-banner__image');
    if (!img) return;
    img.style.animation = 'none';
    void img.offsetWidth;
    img.style.animation = '';
  }

  function setFocusable(slide, focusable) {
    slide.querySelectorAll('a, button').forEach((el) => {
      if (focusable) {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', '-1');
      }
    });
  }

  function initHeroSlider(root) {
    if (root.dataset.heroSliderReady) return;
    root.dataset.heroSliderReady = 'true';

    const slides = Array.from(root.querySelectorAll('.hero-slider__slide'));
    if (slides.length < 2) return;

    const dots = Array.from(root.querySelectorAll('.hero-slider__dot'));
    const autoplay = root.dataset.autoplay === 'true';
    const speed = (parseFloat(root.dataset.autoplaySpeed) || 5) * 1000;

    let activeIndex = Math.max(
      slides.findIndex((slide) => slide.classList.contains('is-active')),
      0
    );
    let timer = null;

    slides.forEach((slide, i) => setFocusable(slide, i === activeIndex));

    function goTo(index) {
      const nextIndex = (index + slides.length) % slides.length;
      if (nextIndex === activeIndex) return;

      slides[activeIndex].classList.remove('is-active');
      slides[activeIndex].setAttribute('aria-hidden', 'true');
      setFocusable(slides[activeIndex], false);

      if (dots[activeIndex]) {
        dots[activeIndex].classList.remove('is-active');
        dots[activeIndex].setAttribute('aria-selected', 'false');
      }

      slides[nextIndex].classList.add('is-active');
      slides[nextIndex].setAttribute('aria-hidden', 'false');
      setFocusable(slides[nextIndex], true);
      if (!prefersReducedMotion()) restartKenBurns(slides[nextIndex]);

      if (dots[nextIndex]) {
        dots[nextIndex].classList.add('is-active');
        dots[nextIndex].setAttribute('aria-selected', 'true');
      }

      activeIndex = nextIndex;
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      if (!autoplay || prefersReducedMotion() || document.hidden) return;
      stop();
      timer = window.setInterval(() => goTo(activeIndex + 1), speed);
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        goTo(i);
        start();
      });
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    start();
  }

  function init() {
    document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-hero-slider]');
      if (root) initHeroSlider(root);
    });
  }
})();
